import { VDivider } from 'vuetify/lib/components/VDivider';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data)?_c('div',[_c(VDivider)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }